import { LicenseToDriveOutputWithStatus } from './license-to-drive-output-with-status.model';


export class LicenseToDriveSelectByIdOutput implements ILicenseToDriveSelectByIdOutput {
    status!: number;
    message!: string;
    data!: LicenseToDriveOutputWithStatus;

    constructor(data?: ILicenseToDriveSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? LicenseToDriveOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LicenseToDriveSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ILicenseToDriveSelectByIdOutput {
    status: number;
    message: string;
    data: LicenseToDriveOutputWithStatus;
}

